import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";

import {
  Container,
  Badge,
  UncontrolledTooltip,
  Col,
  Row,
  Button,
  Card,
} from "reactstrap";
import ReactBsTable from "components/Tables/ReactBsTable";
import DynamicFormModal from "components/Modal/Form";
import { dealTabFormFields } from "variables/formFields";
import {
  getStatusBadge,
  revenueProgressFormatter,
} from "components/Table_Details/Table_Details";
import { showAlert } from "components/Common/commonFunctions";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import SearchableDropdown from "components/DropDown/SearchableDropdown";
import { DATE_RANGE_OPTIONS } from "variables/constants";
import NotificationAlert from "react-notification-alert";
import {
  createDeal,
  updateDeal,
  getDealList,
  getDealDetailsById,
} from "actions/deal";
import { STATUS_OPTIONS } from "variables/constants";
import { getPublisherList } from "actions/publisher";
import {
  getProductTypeList,
  getProductTypeListByPublisherID,
} from "actions/productType";
import { tagDetails } from "actions/tag";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DEAL_TAG_STATUS_OPTIONS } from "variables/constants";

const sortFieldMap = {
  publisher_name: "CompanyName",
  name: "Name",
  productTypeID: "ProductTypeName",
  dealType: "DealType",
  dealTypeValue: "DealTypeValue",
  createdAt: "CreatedAt",
};

const Deal = () => {
  const [deals, setdeals] = useState({
    data: [],
    totalRecords: 0,
  });
  const [dropDownData, setDropDownData] = useState({
    publisherData: [],
    productTypeData: [],
    publisherProductData: [],
  });
  const [dropDownOtherData, setdropDownOtherData] = useState({
    publisherData: { pageNum: 1, searchString: "", totalRecords: 0 },
    productTypeData: { pageNum: 1, searchString: "", totalRecords: 0 },
  });
  const [sortConfig, setSortConfig] = useState({
    dataField: "",
    sortField: "",
    sortOrder: "",
  });
  const navigate = useNavigate();
  const notificationAlertRef = useRef(null);
  const [showAddMdoal, setshowAddMdoal] = useState({
    formType: "Create New Deal",
    show: false,
  });
  const [showLoader, setshowLoader] = useState(false);
  const [showCreateTagWarning, setshowCreateTagWarning] = useState(false);
  const [selected, setSelected] = useState(null);
  const [formState, setFormState] = useState({
    values: { status: true, tstatus: true },
    errors: {},
  });
  const [initialFormValues, setInitialFormValues] = useState({});
  const [previousDealDates, setPreviousDealDates] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [filters, setFilters] = useState({
    deal_name: "",
    company_name: "",
    product_type: "",
    date_range: "",
    start_date: "",
    end_date: "",
    status: "",
    tag_Status: "",
    start_date: "",
    filterParams: [],
  });
  const [publisherOptions, setPublisherOptions] = useState([]);
    const [pageSize, setpageSize] = useState(50);
  const isEditMode = !!selected; // Check selected row is Edit mode or not.
  const getPublisherOptions = async (searchString = "") => {
    try {
      const res = await getPublisherList(0, [], searchString);
      const options =
        res?.code === 200
          ? (res?.data?.Publisher || []).map((item) => ({
            label: item?.companyName || "",
            value: item?.ID || "",
          }))
          : [];
      setPublisherOptions(options);
    } catch (error) {
      console.error("Failed to load publisher options", error);
    }
  };

  // COMBINED useEffect - removed separate sort useEffect
  useEffect(() => {
    getDealListData();
  }, [pageNum, filters.filterParams, pageSize, sortConfig.sortField, sortConfig.sortOrder]);

  useEffect(() => {
    getPublisherOptions();
  }, []);

  const handlePublisherSearch = useCallback(({ query }) => {
    getPublisherOptions(query);
  }, []);

  // New function to fetch product types by publisher ID
  const getPublisherProductTypes = async (publisherID) => {
    try {
      let res = {};
      if (publisherID) {
        res = await getProductTypeListByPublisherID(publisherID);
      } else {
        res = await getProductTypeList();
      }

      // Check if res exists and has data
      let productTypeData = [];

      if (res && Array.isArray(res)) {
        // If res is already an array
        const productTypes = res?.data?.ProductType || res?.data || [];
        productTypeData = productTypes
          .filter((item) => item?.status === "ACTIVE")
          .map((item) => ({
            label: item?.name || "",
            value: item?.ID,
          }));
      } else if (res?.code === 200 && res?.data) {
        // If res has the standard API response structure
        const productTypes = res?.data?.ProductType || res?.data || [];
        productTypeData = productTypes
          .filter((item) => item?.status === "ACTIVE")
          .map((item) => ({
            label: item?.name || "",
            value: item?.ID,
          }));
      } else if (res?.data) {
        // If data is directly in res.data
        const productTypes = Array.isArray(res.data) ? res.data : [];
        productTypeData = productTypes
          .filter((item) => item?.status === "ACTIVE")
          .map((item) => ({
            label: item?.name || "",
            value: item?.ID,
          }));
      }
      if (publisherID) {
        setDropDownData((prev) => ({
          ...prev,
          productTypeData: productTypeData,
        }));
      } else {
        setDropDownData((prev) => ({
          ...prev,
          productTypeData: productTypeData,
        }));
      }
    } catch (error) {
      console.log("Error fetching product types:", error);
      setDropDownData((prev) => ({
        ...prev,
        publisherProductData: [],
      }));
    }
  };

  // => getDealDetails function is used for get Deal Details against dealId and show on form in edit mode.
  const getDealDetails = async (deals) => {
    try {
      const res = await getDealDetailsById(deals?.ID);
      // const tagRes = await tagDetails(deals?.publisher?.ID);
      if (res.code === 200) {
        // Store Publisher Details in state and show on screen
        let data = res?.data;

        // First set the form values
        const loadedValues = {
          name: data.name,
          publisher_name: data.publisher?.ID,
          product_type: data?.productTypeID?.ID,
          demandPartner:data?.demandPartner,
          status: data.status === "ACTIVE" ? true : false,
          start_date: data.startDate ? new Date(data.startDate) : "",
          revenueShare:
            data?.dealType === "REVENUE_SHARE" && data.dealTypeValue,
          ecpm: data.dealType === "ECPM" && data.dealTypeValue,
          dealType: data.dealType,
          adUnitCodes: Array.isArray(data.adUnitCodes)
            ? data.adUnitCodes
            : data.adUnitCodes
            ? data.adUnitCodes
            : data.adUnitCode
            ? [data.adUnitCode]
            : [],
        };

        setFormState({
          values: loadedValues,
          errors: {},
        });
        setInitialFormValues(loadedValues);
        // store previous deal dates for showing history in edit modal
        setPreviousDealDates(Array.isArray(data.dealDates) ? data.dealDates : []);

        // Then fetch product types based on selected publisher

        await getPublisherProductTypes(data.publisher?.ID);

        // notify("success", res?.message);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", error?.message);
    }
  };

  //==> handleEditDeal function is used for to call API's and open a modal.
  const handleEditDeal = (deals) => {
    setSelected(deals);
    setshowAddMdoal({
      formType: "Edit Deal",
      show: true,
    });
    getDealDetails(deals);
    getDropDownData();
    fetchPublishers();
  };

  //==> handleRowClick function is used for naviagte to deal details page.
  const handleRowClick = (row) => {
    navigate("/admin/deal/details", { state: row });
  };

  //Sort Function
  const handleSortChange = (dataField, sortOrder) => {
    const mappedSortField = sortFieldMap[dataField] || dataField;
    setSortConfig({ dataField, sortField: mappedSortField, sortOrder });
    // setPageNum(1);
  };

  // ===> columns is used for to show the columns on Deal List.
  const columns = [
    {
      dataField: "publisher_name",
      text: "Publisher",
      sort: true,
      formatter: (cell, row) => row?.publisher?.companyName || "-",
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "name",
      text: "Deal Name",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "productTypeID",
      text: "Product Type",
      sort: false,
      formatter: (cell, row) => row?.productTypeID?.name || "-",
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "dealType",
      text: "Deal Type",
      sort: false,
      // formatter: (cell) => revenueProgressFormatter(cell),
    },

    {
      dataField: "dealTypeValue",
      text: "Deal Type Value",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "createdAt",
      text: "Created On",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },

    {
      dataField: "adUnitCode",
      text: "Gam Code",
      sort: false,
      formatter: (cell, row) => {
        const gam = row?.adUnitCodes || row?.gamNetworkID || row?.adUnitCode || [];

        if (Array.isArray(gam)) {
          const visibleItems = gam.slice(0, 2);
          const remainingCount = gam.length - visibleItems.length;

          return (
            <div>
              {visibleItems.map((item, index) => (
                <div key={index}>• {item}</div>
              ))}

              {remainingCount > 0 && (
                <div>+{remainingCount} more</div>
              )}
            </div>
          );
        }

        return gam || "-";
      },
    },
    {
      text: "Tag Status",
      dataField: "dealTagStatus",
      sort: true,
      // headerAlign: "center",
      // align: "center",
      formatter: (cell, row) =>
        row?.dealTagID !== 0 ? getStatusBadge(cell) : getStatusBadge("PENDING"),
    },
    {
      text: "Deal Status",
      dataField: "status",
      sort: true,
      // headerAlign: "center",
      // align: "center",
      formatter: (cell) => getStatusBadge(cell),
    },
    {
      text: "Actions",
      dataField: "actions",
      headerAlign: "center",
      formatter: (cell, row) => {
        const rowId = row.ID;

        return (
          <div
            key={rowId}
            style={{ display: "flex", justifyContent: "center", gap: "12px" }}
          >
            <div>
              <a
                className="table-action table-action-info"
                id={`tooltipEdit${rowId}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditDeal(row);
                }}
              >
                <i className="fas fa-edit" />
              </a>
              <UncontrolledTooltip delay={0} target={`tooltipEdit${rowId}`}>
                Edit Deal
              </UncontrolledTooltip>

              <a
                className={`table-action table-action-delete ${row.status === "ACTIVE" ? "status-active" : "status-inactive"
                  }`}
                id={`tooltipToggle${rowId}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleStatusToggle(row);
                }}
              >
                {row.status === "ACTIVE" ? (
                  <i className="fa-solid fa-xmark" />
                ) : (
                  <i className="fa-solid fa-check" />
                )}
              </a>
              <UncontrolledTooltip delay={0} target={`tooltipToggle${rowId}`}>
                {row.status === "ACTIVE" ? "Mark Inactive" : "Mark Active"}
              </UncontrolledTooltip>
            </div>
          </div>
        );
      },
    },
  ];

  //===> Deal List Api Call
  const getDealListData = async () => {
    try {
      setshowLoader(true);
      const res = await getDealList(
        pageNum,
        filters.filterParams,
        "",
        pageSize,
        sortConfig.sortField,
        sortConfig.sortOrder,
      );
      if (res.code === 200) {
        // setData(res?.data); // Set List Data according to api response.
        setshowLoader(false);
        setdeals({
          data: res?.data.Deal,
          totalRecords: res.data.totalRecords,
        });
        // setTotalRecords(res.data.totalRecords);
        // notify("success", res?.message);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      console.error("Error fetching deal list:", error);
    } finally {
      setshowLoader(false);
    }
  };

      const handleSizePerPageChange = (e) => {
        const newSize = Number(e.target.value);
        setpageSize(newSize);
        setPageNum(1);
    };


  //======================== GEtDropdown Data =======================
  //===> getDropDownData function is used for call API's and patch list with dropdown.
  const getDropDownData = async () => {
    try {
      const [] = await Promise.all([
      
        getPublisherProductTypes(),
      ]);

    

  
      setDropDownData((prev) => ({
        ...prev,

      
      }));
      setdropDownOtherData({

        publisherData: {
          totalRecords: 0,
          pageNum: dropDownOtherData?.publisherData.pageNum,
          searchString: "",
        },
      });
    } catch (error) {
      console.error("Dropdown API error:", error?.message);
      // notify("danger", "Something went wrong while loading dropdown data");
    }
  };

  //==> fetchPublishers function is used for getAll Publishers and patch in dropdown.
  const fetchPublishers = async () => {
    try {
      const publisherRes = await getPublisherList();
      const publisherData =
        publisherRes?.code === 200
          ? (publisherRes?.data?.Publisher || []).map((item) => ({
            label: item?.companyName || "",
            value: item?.ID,
          }))
          : [];
      setDropDownData((prev) => ({
        ...prev,
        publisherData: publisherData, // 📜 append on scroll
      }));

      setdropDownOtherData = (prev) => ({
        ...prev,
        publisherData: {
          totalRecords: publisherRes?.data?.totalRecords,
          pageNum: dropDownOtherData?.publisherData.pageNum,
          searchString: "",
        },
      });
    } catch (error) { }
  };

  useEffect(() => {
    const { pageNum, totalRecords, searchString } =
      dropDownOtherData.publisherData;

    const currentLength = dropDownData.publisherData.length;

    // 🔍 When searching → always call API
    if (searchString) {
      fetchPublishers();
      return;
    }

    // ❌ Search cleared AND we already have data → reload first page
    if (
      !searchString &&
      totalRecords > 0 &&
      pageNum === 1 &&
      currentLength === 0
    ) {
      fetchPublishers();
      return;
    }

    // ⬇️ Infinite scroll case
    if (pageNum > 1 && currentLength < totalRecords) {
      fetchPublishers();
    }

    if (pageNum === 1 && currentLength === 0) {
      getDropDownData();
    }
  }, [
    dropDownOtherData.publisherData.pageNum,
    dropDownOtherData.publisherData.searchString,
  ]);

  //======================== GEtDropdown Data =======================

  //===> openAddModal is used for open a add modal.
  const openAddModal = () => {
    setshowAddMdoal({
      formType: "Create New Deal",
      show: !showAddMdoal.show,
    });
    setFormState({ values: { status: true, tstatus: true }, errors: {} });
    setInitialFormValues({});
    setSelected(null);
    // Reset product types when opening modal
    setDropDownData((prev) => ({
      ...prev,
      publisherProductData: [],
    }));
    const { pageNum, totalRecords, searchString } =
      dropDownOtherData.publisherData;
    const currentLength = dropDownData.publisherData.length;
    if (pageNum === 1 && currentLength === 0) {
      fetchPublishers();
    }
    // getDropDownData();
  };

  //
  const getPublisherDropdownData = async (value) => {
    try {
      // Reset product type value when publisher changes
      setFormState((prev) => ({
        ...prev,
        values: {
          ...prev.values,
          product_type: "",
        },
      }));

      // Fetch product types based on selected publisher
      await getPublisherProductTypes(value);
    } catch (error) {
      console.log("error", error);
    }
  };

  //=> getTagDetailsByDealID function is used for get tag deatils bby deal Id in edit mode.
  const getTagDetailsByDealID = async () => {
    try {
      const res = await tagDetails(selected?.dealTagID);
      if (res?.code === 200) {
        setFormState((prev) => ({
          ...prev,
          values: {
            ...prev.values,
            tag_name: res?.data.tagName,
            tag_content: res?.data.content,
            tstatus: res?.data.status === "ACTIVE",
          },
          errors: {},
        }));
      } else {
        setshowCreateTagWarning(true);
      }
    } catch (error) { }
  };

  //=> handleInputChange function is used for set the form values in a state.
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "publisher_name") {
      getPublisherDropdownData(value);
    }

    setFormState((prev) => {
      const updatedValues = {
        ...prev.values,
        [name]: value,
      };

      const updatedErrors = {
        ...prev.errors,
        [name]: undefined,
      };

      /* -------------------------
       Revenue Share validation
    -------------------------- */
      if (name === "revenueShare") {
        const numericValue = Number(value);

        // Allow empty input
        if (value === "") {
          updatedErrors.revenueShare = undefined;
        }
        // Invalid number
        else if (isNaN(numericValue)) {
          updatedErrors.revenueShare = "Revenue share must be a number";
        }
        // Max 100 validation
        else if (numericValue > 100) {
          updatedErrors.revenueShare = "Revenue share cannot exceed 100";
        } else if (numericValue < 0) {
          updatedErrors.revenueShare = "Revenue share cannot be less than 0";
        }
      }

      /* -------------------------
       Existing logic
    -------------------------- */
      if (selected && name === "create_tag" && value === true) {
        getTagDetailsByDealID();
      }

      dealTabFormFields(
        dropDownData?.publisherData,
        dropDownData?.productTypeData,
     
      ).forEach((field) => {
        if (field.showWhen?.field === name) {
          const conditionMet =
            field.showWhen.equals === value ||
            field.showWhen?.in?.includes?.(value);

          if (!conditionMet) {
            if (field.name === "tstatus") {
              updatedValues[field.name] = value;
            } else {
              updatedValues[field.name] = "";
            }
            updatedErrors[field.name] = undefined;
          }
        }
      });

      return {
        values: updatedValues,
        errors: updatedErrors,
      };
    });
  };

  //==> handleManageModal function is used for close the modal.
  const handleManageModal = () => {
    if (showLoader !== true) {
      setFormState({
        values: { status: true, tstatus: true },
        errors: {},
      });
      setInitialFormValues({});
      setshowAddMdoal(!showAddMdoal);
      setshowCreateTagWarning(false);
      // Reset product types when closing modal
      setDropDownData((prev) => ({
        ...prev,
        publisherProductData: [],
      }));
    }
  };

  //===> notify function is used for to show notification on create and update the deal.
  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };
  //======================== Form Validation and submit form =======================

  const validateForm = (fields, values) => {
    const errors = {};

    fields.forEach((field) => {
      // 🔹 1. Handle conditional validation (showWhen)
      if (field.showWhen) {
        const { field: dependsOn, equals } = field.showWhen;
        const dependentValue = values[dependsOn];

        const shouldValidate = Array.isArray(equals)
          ? equals.includes(dependentValue)
          : dependentValue === equals;

        if (!shouldValidate) return; // ❌ skip validation
      }

      // 🔹 2. Required validation
      const val = values[field.name];
      const isEmptyArray = Array.isArray(val) && val.length === 0;
      if (field.required && (val === undefined || val === "" || isEmptyArray)) {
        errors[field.name] = `${field.label} is required`;
        return;
      }

      // 🔹 3. Number range validation
      if (
        field.type === "number" &&
        values[field.name] !== undefined &&
        values[field.name] !== "" &&
        (Number(values[field.name]) < field.min ||
          Number(values[field.name]) > field.max)
      ) {
        errors[field.name] =
          `${field.label} must be between ${field.min} and ${field.max}`;
      }
    });
    return errors;
  };

  const normalizeDealPayload = (values) => {
    if (!values) return {};

    const payload = {
      ...(values.name !== undefined && { name: values.name }),
      ...(values.publisher_name !== undefined && {
        publisherID: values.publisher_name,
      }),
      ...(values.adUnitCodes !== undefined && {
        adUnitCodes: values.adUnitCodes,
      }),
      ...(values.product_type !== undefined && {
        productTypeID: values.product_type,
      }),
      ...(values.dealType !== undefined && { dealType: values.dealType }),
      ...(values.dealType !== undefined && {
        dealTypeValue:
          values.dealType === "ECPM"
            ? parseFloat(values.ecpm)
            : parseFloat(values.revenueShare),
      }),
      ...(values.demandPartner!==undefined&&{demandPartner:values?.demandPartner}),
      ...(values.status !== undefined && {
        status: values.status ? "ACTIVE" : "INACTIVE",
      }),
      ...(values.start_date !== undefined && {
        startDate: values.start_date
          ? moment(values.start_date).format("YYYY-MM-DD")
          : "",
      }),
      ...(values.create_tag !== undefined && { createTag: values.create_tag }),
    };

    if (values.create_tag) {
      payload.tag = {
        ...(showAddMdoal?.formType === "Edit Deal" && {
          ID: selected?.dealTagID,
        }),
        publisherID: values.publisher_name,
        name: values.tag_name,
        content: values.tag_content,
        status: values.tstatus ? "ACTIVE" : "INACTIVE",
      };
    }

    return payload;
  };

  const getChangedPayload = (currentValues, originalValues) => {
    const currentPayload = normalizeDealPayload(currentValues);
    const originalPayload = normalizeDealPayload(originalValues);
    return Object.entries(currentPayload).reduce((acc, [key, value]) => {
      if (key === "tag") {
        const originalTag = originalPayload.tag || {};
        const changedTag = Object.entries(value).reduce((tagAcc, [tagKey, tagValue]) => {
          if (tagValue !== originalTag[tagKey]) {
            tagAcc[tagKey] = tagValue;
          }
          return tagAcc;
        }, {});

        if (Object.keys(changedTag).length > 0) {
          acc.tag = changedTag;
        }
        return acc;
      }

      const originalValue = originalPayload[key];
      const valuesDiffer =
        value !== originalValue &&
        !(Number.isNaN(value) && Number.isNaN(originalValue));

      if (valuesDiffer) {
        acc[key] = value;
      }

      return acc;
    }, {});
  };



//===> handleSubmit function is used for create and update the deal.
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setshowLoader(true);

      const errors = validateForm(
        dealTabFormFields(
          dropDownData?.publisherData,
          dropDownData?.productTypeData,
        ),
        formState.values,
      );

    if (Object.keys(errors).length) {
      setFormState((prev) => ({
        ...prev,
        errors,
      }));

      setshowLoader(false);
      return;
    }

    const changedPayload = getChangedPayload(
      formState.values,
      initialFormValues,
    );

    const payLoad =
      showAddMdoal?.formType === "Create New Deal"
        ? {
            name: formState?.values.name,
            publisherID: formState?.values.publisher_name,
            adUnitCodes: formState?.values.adUnitCodes,
            productTypeID: formState?.values.product_type,
            status: formState?.values.status ? "ACTIVE" : "INACTIVE",
            demandPartner : formState?.values?.demandPartner,
            dealTypeValue:
              formState.values.dealType === "ECPM"
                ? parseFloat(formState?.values.ecpm)
                : parseFloat(formState?.values.revenueShare),

            dealType: formState.values.dealType,

            startDate: formState.values.start_date
              ? moment(formState.values.start_date).format("YYYY-MM-DD")
              : "",

            createTag:
              formState?.values?.create_tag === undefined
                ? false
                : formState.values.create_tag,

            ...(formState?.values?.create_tag && {
              tag: {
                ...(showAddMdoal?.formType === "Edit Deal" && {
                  ID: selected?.dealTagID,
                }),

                publisherID: formState?.values.publisher_name,
                name: formState?.values.tag_name,
                content: formState?.values.tag_content,
                status: formState?.values.tstatus
                  ? "ACTIVE"
                  : "INACTIVE",
              },
            }),
          }
        : {
            ...changedPayload,
            productTypeID: formState?.values.product_type,
            publisherID:formState.values.publisher_name,
            demandPartner:formState.values.demandPartner,
          };

    if (
      showAddMdoal?.formType !== "Create New Deal" &&
      Object.keys(payLoad).length === 0
    ) {
      notify("info", "No changes detected.");
      setshowLoader(false);
      return;
    }

    // Check if dealType or dealTypeValue changed without startDate
    const dealTypeChanged =
      changedPayload?.dealType !== undefined;

    const dealTypeValueChanged =
      changedPayload?.dealTypeValue !== undefined;

    const startDateChanged =
      changedPayload?.startDate !== undefined;

    const submitDeal = async () => {
      try {
        setshowLoader(true);

        const res =
          showAddMdoal?.formType === "Create New Deal"
            ? await createDeal(payLoad)
            : await updateDeal(selected?.ID, payLoad);

        if (res.code === 200) {
          notify("success", res?.message);

          getDealListData();

          setshowAddMdoal({
            formType: "Create New Deal",
            show: false,
          });
        } else {
          const message = Array.isArray(res?.message)
            ? res?.message[0]?.Msg
            : res?.message || "Something went wrong";

          notify("danger", message);
        }
      } catch (error) {
        notify("danger", error?.message);
      } finally {
        setshowLoader(false);
      }
    };

    // Show confirmation popup

if (
  showAddMdoal?.formType !== "Create New Deal" &&
  (dealTypeChanged || dealTypeValueChanged) &&
  !startDateChanged
) {
  setshowLoader(false);

  let changedFields = [];

  if (dealTypeChanged) {
    changedFields.push("Deal Type");
  }

  if (dealTypeValueChanged) {
    changedFields.push(
       formState.values.dealType === "ECPM"
        ? "eCPM Value"
        : "Revenue Share Value"
    );
  }
  return showAlert({
    title: "Are you sure?",
    message: `You have changed ${changedFields.join(
      " and "
    )} without changing the Start Date.`,
    type: "warning",
    confirmStyle: "secondary",
    cancelStyle: "btn btn-primary btn-gradient-primary",
    confirmText: "Continue",
    cancelText: "Cancel",

    onConfirm: async () => {
      await submitDeal();
    },

    onCancel: () => {
      setshowLoader(false);
    },
  });
}

    await submitDeal();
  } catch (error) {
    setshowLoader(false);
    notify("danger", error?.message);
  }
};

  //======================== Form Validation and submit form =======================

  //==> handleStatusToggle function is used for to show active and inactive pop up.
  const handleStatusToggle = async (row) => {
    const isActive = row.status === "ACTIVE";
    const res = await getDealDetailsById(row?.ID);
    let data = res?.data;

    showAlert({
      title: `Are you sure you want to ${isActive ? "inactivate" : "activate"
        } this deal?`,
      message: `Deal "${row?.name}" will be ${isActive ? "inactive" : "active"
        }.`,
      type: "warning",
      confirmStyle: "secondary",
      cancelStyle: "btn btn-primary btn-gradient-primary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => confirmStatus(data),
      onCancel: () => { },
    });
  };

  //==> confirmStatus function is used for update the deal status.
  const confirmStatus = async (data) => {
    try {
      const payLoad = {
        name: data.name,
        publisherID: data.publisher.ID,
        adUnitCodes: data.adUnitCodes || data.gamNetworkID || (data.adUnitCode ? [data.adUnitCode] : []),
        productTypeID: data.productTypeID?.ID,
        revenueShare: data.revenueShare,
        status: data.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      const res = await updateDeal(data?.ID, payLoad);
      if (res.code === 200) {
        notify("success", res?.message);
        getDealListData();
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) { }
  };

  //====================Filter Section ======================

  //==> showCustomDateInputs is used for Date Range dropdown.
  const showCustomDateInputs = (name, value) => {
    // handleChange(key, value);
    const today = moment().format("YYYY-MM-DD");

    if (value === "Custom Range") {
      setFilters((prev) => ({
        ...prev,
        date_range: value,
        start_date: "",
        end_date: "",
      }));
      // setShowCustomDate(true);
      return;
    }

    let months = 0;
    if (value === "Last 1 Month") months = 1;
    if (value === "Last 3 Month") months = 3;
    if (value === "Last 6 Month") months = 6;
    if (value === "Last 12 Month") months = 12;

    const startDate = moment().subtract(months, "months").format("YYYY-MM-DD");

    setFilters((prev) => ({
      ...prev,
      date_range: value,
      start_date: startDate,
      end_date: today,
    }));
    // setShowCustomDate(true);
  };

  //===> handleFilterChange function is used for set filters values in a state.
  const handleFilterChange = (key, value) => {
    setFilters((prev) => {
      if (key === "start_date") {
        const startDate = value;
        const endDate = prev.end_date;

        // if end_date exists AND start_date <= end_date → keep end_date
        if (endDate && new Date(startDate) <= new Date(endDate)) {
          return {
            ...prev,
            start_date: startDate,
          };
        }

        // otherwise reset end_date
        return {
          ...prev,
          start_date: startDate,
          end_date: "",
        };
      }

      if (key === "company_name" && value !== "") {
        getPublisherProductTypes(value);
      }

      return {
        ...prev,
        [key]: value,
      };
    });
  };

  //==> buildFilterParams function is used for make filterJson array.
  const buildFilterParams = () => {
    const filterParams = [];

    if (filters?.status != "") {
      filterParams.push({
        field: "Status",
        condition: "eq",
        filterValues: [filters?.status],
      });
    }
    if (filters?.product_type != "") {
      filterParams.push({
        field: "ProductTypeID",
        condition: "eq",
        filterValues: [String(filters?.product_type)],
      });
    }
    if (filters?.company_name !== "") {
      filterParams.push({
        field: "PublisherID",
        condition: "eq",
        filterValues: [String(filters?.company_name)],
      });
    }

    if (filters?.deal_name !== "") {
      filterParams.push({
        field: "Name",
        condition: "like",
        filterValues: [filters?.deal_name],
      });
    }
    if (filters?.tag_Status !== "") {
      filterParams.push({
        field: "DealTagStatus",
        condition: "eq",
        filterValues: [filters?.tag_Status],
      });
    }

    if (filters?.start_date !== "" && filters?.end_date !== "") {
      filterParams.push({
        field: "CreatedAt",
        condition: "btw",
        filterValues: [filters?.start_date, filters?.end_date],
      });
    }

    return filterParams.length > 0 ? JSON.stringify(filterParams) : "";
  };

  //==> isAnyFilterApplied function is used for to check is any filter is applied or not to avoid api call.
  const isAnyFilterApplied = (filters) => {
    return Object.entries(filters).some(([key, value]) => {
      if (key === "filterParams") {
        return Array.isArray(value) && value.length > 0;
      }
      return value !== "" && value !== null && value !== undefined;
    });
  };

  //==> handleSearch function is used for search the filters values in a list.
  const handleSearch = () => {
    if (!isAnyFilterApplied(filters)) return;
    const newfilterParams = buildFilterParams();

    setFilters({
      ...filters,
      filterParams: newfilterParams,
    });
    if (pageNum !== 1) setPageNum(1);
  };

  //==> formatDate function is used for to show filter date in human readble.
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  //==> handleReset function is used for reset filters values.
  const handleReset = () => {
    if (!isAnyFilterApplied(filters)) return;

    setFilters({
      deal_name: "",
      company_name: "",
      product_type: "",
      date_range: "",
      start_date: "",
      end_date: "",
      status: "",
      tag_Status: "",
      start_date: "",
      filterParams: [],
    });
    getDropDownData();
    setPageNum(1);
  };

  //==> filterSection is used for show filters on list.
  const filterSection = () => {
    return (
      <>
        <Row className="align-items-center">
          <Col md={2}>
            <SearchableDropdown
              name="company_name"
              options={publisherOptions}
              placeholder="Select Publisher"
              value={filters.company_name}
              onChange={(e) =>
                handleFilterChange("company_name", e.target.value)
              }
              onSearch={handlePublisherSearch}
              isSearchable={true}
            />
          </Col>

          <Col md={2}>
            <SearchableDropdown
              options={dropDownData.productTypeData}
              placeholder="Product Type"
              value={filters.product_type}
              onChange={(e) =>
                handleFilterChange("product_type", e.target.value)
              }
              isSearchable={false}
            />
          </Col>
          <Col md={2}>
            <input
              className="form-control"
              placeholder={"Deal Name"}
              value={filters.deal_name}
              onChange={(e) => handleFilterChange("deal_name", e.target.value)}
            />
          </Col>
          <Col md={2}>
            <SearchableDropdown
              options={STATUS_OPTIONS}
              placeholder="Status"
              value={filters.status}
              onChange={(e) => handleFilterChange("status", e.target.value)}
              isSearchable={false}
            />
          </Col>
        </Row>

        <Row className="mt-2">
          <>
            <Col md={2}>
              <SearchableDropdown
                options={DEAL_TAG_STATUS_OPTIONS}
                placeholder="Tag Status"
                value={filters.tag_Status}
                onChange={(e) =>
                  handleFilterChange("tag_Status", e.target.value)
                }
                isSearchable={false}
              />
            </Col>
            <Col md={2}>
              <SearchableDropdown
                options={DATE_RANGE_OPTIONS}
                placeholder="Date Range"
                value={filters.date_range}
                onChange={(e) =>
                  showCustomDateInputs("date_range", e.target.value)
                }
                isSearchable={false}
              />
            </Col>
            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.start_date ? new Date(filters.start_date) : null
                  }
                  onChange={(date) =>
                    handleFilterChange(
                      "start_date",
                      date ? formatDate(date) : "",
                    )
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="Start Date"
                  className="form-control custom-datepicker"
                  disabled={filters.date_range !== "Custom Range"}
                />
                <i className="ni ni-calendar-grid-58 text-muted calendar-icon" />
              </div>
            </Col>

            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.end_date ? new Date(filters.end_date) : null
                  }
                  onChange={(date) =>
                    handleFilterChange("end_date", date ? formatDate(date) : "")
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="End Date"
                  className="form-control custom-datepicker"
                  /* ✅ disable until start date is selected */
                  disabled={
                    filters.date_range !== "Custom Range" || !filters.start_date
                  }
                  /* ✅ minDate must be a Date object */
                  minDate={
                    filters.start_date
                      ? new Date(filters.start_date)
                      : undefined
                  }
                />
                <i className="ni ni-calendar-grid-58 text-muted calendar-icon" />
              </div>
            </Col>
          </>
          <Col md={4}>
            <Button
              onClick={handleSearch}
              disabled={!isAnyFilterApplied(filters)}
              className="filter-btn-gradient-primary btn-md responsive"
            >
              Search
            </Button>

            <Button
              // className="filter-btn-gradient-secondary btn-md responsive"
              className="secondary"
              disabled={!isAnyFilterApplied(filters)}
              onClick={handleReset}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </>
    );
  };

  const searchDropdownValues = (fieldName) => {
    switch (fieldName?.key) {
      case "publisher_name":
        setdropDownOtherData((prev) => ({
          ...prev,
          publisherData: {
            ...prev.publisherData,
            searchString: fieldName?.query,
            pageNum: 1,
          },
        }));
        break;
      case "product_type":
        setdropDownOtherData((prev) => ({
          ...prev,
          productTypeData: {
            ...prev.productTypeData,
            searchString: fieldName?.query,
            pageNum: 1,
          },
        }));
        break;
        break;
      default:
        break;
    }
  };

  const onLoadMore = (fieldName) => {
    const { searchString } = dropDownOtherData?.publisherData;
    if (searchString !== "") return;
    switch (fieldName) {
      case "publisher_name":
        setdropDownOtherData((prev) => ({
          ...prev,
          publisherData: {
            ...prev.publisherData,
            pageNum: prev.publisherData.pageNum + 1,
          },
        }));
        break;
      case "product_type":
        setdropDownOtherData((prev) => ({
          ...prev,
          productTypeData: {
            ...prev.productTypeData,
            pageNum: prev.productTypeData.pageNum + 1,
          },
        }));
        break;
      default:
        break;
    }
  };

  //====================Filter Section ======================

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Container className="mt--6" fluid>
        <Card>
          <ReactBsTable
            title="Deals"
            description="Deal Management List"
            handleSizePerPageChange={handleSizePerPageChange}
            data={deals?.data}
            columns={columns}
            keyField="ID"
            addbtntext="Add Deal"
            onAddBtnClick={openAddModal}
            handleRowClick={handleRowClick}
            renderFilters={filterSection}
            enablePageSizeManagement={true}
            sizePerPage={pageSize}
            page={pageNum}
            totalRecords={deals?.totalRecords}
            onPageChange={(p) => setPageNum(p)}
            onSortChange={handleSortChange}
            defaultSortField={sortConfig.dataField}
            defaultSortOrder={sortConfig.sortOrder}
            showLoader={showLoader}
          />
        </Card>
        <DynamicFormModal
          isOpen={showAddMdoal?.show}
          toggle={handleManageModal}
          title={showAddMdoal.formType}
          fields={dealTabFormFields(
            dropDownData.publisherData,
            dropDownData.productTypeData,
            formState,
            isEditMode,
          )}
          formData={formState.values}
          errors={formState.errors}
          onChange={handleInputChange}
          onSubmit={handleSubmit}
          previousDealDates={previousDealDates}
          isEditMode={isEditMode}
          // onSearch={searchDropdownValues}
          // onLoadMore={onLoadMore}
          tagError={
            showCreateTagWarning === true &&
              showAddMdoal?.formType === "Edit Deal" &&
              formState.values.create_tag === true
              ? "Tag is not created against this deal."
              : ""
          }
          showLoader={showLoader}
        />
      </Container>
    </>
  );
};

export default Deal;